// removed by extract-text-webpack-plugin
module.exports = {"RoomOpts":"roomOpts__RoomOpts__3MCdL","Container":"roomOpts__Container__1nWe1","Code":"roomOpts__Code__1e4Ka","Opt":"roomOpts__Opt__2LQUX","GgbIcon":"roomOpts__GgbIcon__2VJ06","Selected":"roomOpts__Selected__1d7A0 roomOpts__GgbIcon__2VJ06","OptText":"roomOpts__OptText__14A5P"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Create/NewResource/roomOpts.css
// module id = 1220
// module chunks = 2